<template>
  <v-overlay
    persistent
    v-model="localIsSaving"
    class="d-flex align-center justify-center text-center"
  >
    <div class="d-flex flex-column align-center">
      <span class="mb-2" :style="{ color: color }">{{ loadingText }}</span>
      <v-progress-circular :color="color" :indeterminate="isIndeterminate" :size="chosenSize">
        <template #default>
          {{ loadingPercentage }}
        </template>
      </v-progress-circular>
    </div>
  </v-overlay>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  color: {
    type: String,
    default: '#13334a'
  },
  loadingPercentage: {
    type: String,
    default: ''
  },
  loadingText: {
    type: String,
    default: 'Saving...'
  },
  chosenSize: {
    type: String,
    default: '128'
  },
  isIndeterminate: {
    type: Boolean,
    default: true
  },
  isSaving: {
    type: Boolean,
    default: false
  }
})

const localIsSaving = ref<boolean>(props.isSaving)
watch(
  () => props.isSaving,
  (newVal) => {
    localIsSaving.value = newVal
  }
)
</script>
